<template>
  <div class="w-full">
    <div class="note rounded-lg shadow border">
      <div style="height: 200px" ref="editor"></div>
    </div>
    <lms-button @click="$emit('save', {})" class="mt-4">Save</lms-button>
    <lms-button @click="$emit('download', {})" class="mt-4 ml-3"
      >Download To Pdf</lms-button
    >
  </div>
</template>
<script>
import Quill from "quill";
// import quillEmij from "quill-emoji/dist/quill-emoji";
// import "quill-emoji/dist/quill-emoji.css";

export default {
  name: "note-journal",
  props: {
    value: {},
  },
  data() {
    return {
      editor: "",
    };
  },
  watch: {
    value: () => {
      // //console.log("changes")
    },
  },
  components: {
    LmsButton: () => import("@/components/general/button"),
  },
  mounted() {
    // Init the Quill RTE
    const toolbarOptions = {
      container: [
        [{ header: [1, 2, 3, 4, 5, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
      ],
    };

    // Init the Quill RTE
    this.editor = new Quill(this.$refs.editor, {
      placeholder: "Begin Your Journal Here",
      theme: "snow",
    });
    this.editor.root.innerHTML = this.value;
    // this.$emit("input", this.$refs.journal.innerHTML)

    this.editor.on("text-change", () => this.update());
  },
  methods: {
    update() {
      this.$emit(
        "input",
        this.editor.getText() ? this.editor.root.innerHTML : ""
      );
    },
  },
};
</script>
